
<div class="not-found" style="padding-top: 30px;">
   <h1>404</h1>
   <span class="message">
   Oops, looks like the page you're looking for doesn't exist. You can
   try one of the links below or <a href="/" replace>click here</a> to return
   to the homepage.
   </span>  
</div>